import { Link } from "react-router-dom";
import {useEffect} from  'react';

function FrontPage() {  
  useEffect(() => {
    document.body.className = "frontpage page"
    return () => {
      document.body.classList.remove("frontpage", "page");
    }
  }, []);

  return (
      <div className="centerBox">
        <div className="frontpage title">
          2<br />
          five<br />
          five<br />
        </div>

        <Link className="icon" to="/blog"> blog </Link>
        <a className="icon" href="https://github.com/Toofty5/">github</a>
        {/* <a class="icon" href="about.html">about</a> */}
      </div>
  );

}


export default FrontPage;
